import * as React from "react"

const SMALL_SCREEN_BREAKPOINT = 1024 // lg breakpoint

/**
 * Hook to detect if the screen is small (xs, sm, md - less than lg breakpoint)
 * Returns true for screens < 1024px (xs, sm, md)
 * Returns false for screens >= 1024px (lg, xl, 2xl)
 */
export function useIsSmallScreen() {
  const [isSmallScreen, setIsSmallScreen] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${SMALL_SCREEN_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsSmallScreen(window.innerWidth < SMALL_SCREEN_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsSmallScreen(window.innerWidth < SMALL_SCREEN_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isSmallScreen
}

